import dashboard from './dashboard';
import { forecitePrompts, watchfullPrompts, sharedPrompts } from "./prompts";
import documentation from "./documentation";
import users from "./users";
import monitor from "./monitor";
import applications from "./applications";

// ==============================|| MENU ITEMS ||============================== //

async function getMenus(){
  let monitors = await monitor();
  return {
    items: [dashboard, forecitePrompts, watchfullPrompts, sharedPrompts, monitors, users, applications, documentation]
  };
}

export default getMenus;
